import type {
  FilterConditionPluginSpecification,
} from '../filter.plugin';
import {
  FilterConditionPluginImpl
} from '../filter.plugin';
import type {
  BdCondition,
} from '@bindoc-projects/condition-domain-lib';
import {
  BdContentCondition,
} from '@bindoc-projects/condition-domain-lib';
import { BdArrayUtil } from '@bindoc-projects/util-domain-lib';
import { AysCodeGroup } from '@bindoc-projects/code-domain-lib';

export const BD_OPS_CHAPTER_CONTENT_CONDITION_ID = 'opsChapter';
export const FilterConditionOpsCodeChapterPluginType: FilterConditionPluginSpecification<
  AysCodeGroup[],
  FilterConditionOpsCodeChapterDto,
  BdOpsChapterContentCondition
> = {
  type: 'opsChapter',
  category: 'case',
  displayName: { de: 'OPS-Kapitel' },
  sortingIndex: 8,
  occurrence: 'single',
  fromObject(
    obj: FilterConditionOpsCodeChapterDto,
  ): FilterConditionPluginImpl<AysCodeGroup[]> {
    return new FilterConditionOpsCodeChapterPlugin(
        obj.chapters.map((it) => AysCodeGroup.fromObject(it)),
      );
  },
  fromCondition(
    jsonObj: BdOpsChapterContentCondition,
  ): FilterConditionPluginImpl<AysCodeGroup[]> {
    return new FilterConditionOpsCodeChapterPlugin(
        (jsonObj.includes ?? []).map((it) => AysCodeGroup.fromObject(it)),
      );
  },
  newInstance(): FilterConditionPluginImpl<AysCodeGroup[]> {
    return new FilterConditionOpsCodeChapterPlugin([]);
  },
};

export class FilterConditionOpsCodeChapterPlugin extends FilterConditionPluginImpl<
  AysCodeGroup[],
  FilterConditionOpsCodeChapterDto
> {
  public static override Specification: FilterConditionPluginSpecification<
    AysCodeGroup[],
    FilterConditionOpsCodeChapterDto,
    BdOpsChapterContentCondition
  > = FilterConditionOpsCodeChapterPluginType;

  constructor(private chapters: AysCodeGroup[]) {
    super(FilterConditionOpsCodeChapterPluginType.type);
  }

  clone(): FilterConditionOpsCodeChapterPlugin {
    return new FilterConditionOpsCodeChapterPlugin([
      ...this.chapters.map((it) => it.clone()),
    ]);
  }

  override equals(other: FilterConditionOpsCodeChapterPlugin): boolean {
    return (
      super.equals(other) &&
      BdArrayUtil.equals(
        this.chapters,
        other.chapters,
        (a, b) => a.name === b.name && a.codingSystem === b.codingSystem,
      )
    );
  }

  override validationToText(): string {
    if (this.chapters.length === 0) {
      return 'Mindestens ein OPS-Kapitel auswählen';
    } else {
      return '';
    }
  }

  toCondition(): BdCondition | null {
    return new BdOpsChapterContentCondition(this.chapters, []);
  }

  toJSON(): FilterConditionOpsCodeChapterDto | null {
    return {
      type: this.type,
      chapters: this.chapters,
    };
  }

  toText(): string | null {
    return 'OPS-Kapitel';
  }

  toValue(): AysCodeGroup[] {
    return this.chapters;
  }
}

export class BdOpsChapterContentCondition extends BdContentCondition<AysCodeGroup> {
  constructor(includes: AysCodeGroup[], excludes: AysCodeGroup[]) {
    super(BD_OPS_CHAPTER_CONTENT_CONDITION_ID, includes, excludes);
  }
}

interface FilterConditionOpsCodeChapterDto {
  type: string;
  chapters: AysCodeGroup[];
}
